import { Link } from "react-router-dom";
import { CTA_URL, HANDLE, INSTAGRAM_URL, TIKTOK_URL, TIKTOK_HANDLE } from "@/lib/copy";
import { Instagram } from "lucide-react";
import TikTokIcon from "@/components/icons/TikTokIcon";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="relative overflow-hidden bg-[var(--bg)] px-6 pt-12 md:px-12 md:pt-16"
      data-testid="footer-section"
    >
      <div className="mx-auto max-w-[1440px]">
        {/* Massive wordmark */}
        <div className="relative -mx-2 pb-4">
          <h2
            aria-hidden
            className="select-none whitespace-nowrap text-center font-serif text-[28vw] leading-[0.85] tracking-[-0.05em] text-white md:text-[22vw]"
          >
            <span className="italic text-[var(--pink)]">j</span>ulssy
          </h2>
        </div>

        <div className="mt-6 flex flex-col items-center gap-4 border-t border-white/10 py-8 font-mono text-[11px] uppercase tracking-super text-white/45 md:flex-row md:justify-between">
          <div>© {year} Julssy · Todos os direitos reservados</div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 transition hover:text-[var(--pink)]"
            data-testid="footer-instagram-link"
          >
            <Instagram className="h-3.5 w-3.5" strokeWidth={2.2} />
            {HANDLE}
          </a>
          <a
            href={TIKTOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 transition hover:text-[var(--pink)]"
            data-testid="footer-tiktok-link"
          >
            <TikTokIcon className="h-3.5 w-3.5" />
            {TIKTOK_HANDLE}
          </a>
          <a
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="transition hover:text-[var(--pink)]"
            data-testid="footer-fatalfans-link"
          >
            fatalfans.com/julssynha ↗
          </a>
        </div>

        {/* Discreet admin link */}
        <div className="flex justify-center border-t border-white/5 py-3">
          <Link
            to="/admin/login"
            className="font-mono text-[9px] uppercase tracking-super text-white/20 transition hover:text-white/60"
            data-testid="footer-admin-link"
          >
            admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
